<section *ngIf="user$ | async as user">
  <fsx-shared-sidenav></fsx-shared-sidenav>
  <main class="content-area">
    <router-outlet class="auth-outlet"></router-outlet>
  </main>
  <fsx-loading-spinner *ngIf="isLoading$ | async"></fsx-loading-spinner>
</section>
